// extracted by mini-css-extract-plugin
export default {"container":"WhoToFollow_container__oVzmD"};